export const TIPOS = [
  { id: 1, value: 'NFSE' },
  { id: 2, value: 'BOLETO' },
]

export const FORMATOS = [
  { id: 1, value: 'XML' },
  { id: 2, value: 'JSON' },
]

export const OPTIONS_FILTER_TIPO = [
  { label: 'TODOS', value: '' },
  { label: 'NFSE', value: 1 },
  { label: 'BOLETO', value: 2 },
]

export const OPTIONS_FILTER_FORMATO = [
  { label: 'TODOS', value: '' },
  { label: 'XML', value: 1 },
  { label: 'JSON', value: 2 },
]
